var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.category)?_c(_vm.pageTemplate,{key:_vm.key,tag:"component"}):_c('not-found')
}
var staticRenderFns = []

export { render, staticRenderFns }